import { render, staticRenderFns } from "./vResidentRequests.vue?vue&type=template&id=2a64282a&scoped=true"
import script from "./vResidentRequests.vue?vue&type=script&lang=js"
export * from "./vResidentRequests.vue?vue&type=script&lang=js"
import style0 from "./vResidentRequests.vue?vue&type=style&index=0&id=2a64282a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a64282a",
  null
  
)

export default component.exports